import ButtonAdd from "@/shared/components/atoms/ButtonAdd";
import { ButtonWhite } from "@/shared/components/atoms/ButtonWhite";
import TabsUI from "@/shared/components/atoms/TabsUI";
import { Badges } from "@/shared/components/molecules/Badges";
import Stacked from "@/shared/components/molecules/Stacked";
import { t } from "i18next";

export const LeadPage = () => {
  const task = t("lead.views.tasks");
  const notes = t("lead.views.notes");
  const businessStage = t("lead.views.business_stage_registration");
  const tabs = [
    {
      name: task,
      href: "/leads/tasks",
      current: true,
    },
    {
      name: notes,
      href: "/leads/notes",
      current: false,
    },
    {
      name: businessStage,
      href: "/leads/business-stage",
      current: false,
    },
  ];
  return (
    <div className="mx-auto px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto grid max-w-2xl grid-cols-1 items-start gap-x-8 gap-y-8 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        <Stacked />
        <div className="flex-1 lg:col-start-2 lg:col-end-4">
          <div className="px-4">
            <TabsUI tabs={tabs} />
          </div>
          <div className="mt-1 w-full">
            <div className="pt-3 flex justify-end gap-x-4">
              <ButtonWhite
                text={t("lead.views.list_tasks_complete")}
                functionButton={() => {}}
              />
              <ButtonWhite
                text={t("lead.views.list_tasks_past")}
                functionButton={() => {}}
              />
              <ButtonAdd functionButton={() => {}} />
            </div>
            <Badges />
          </div>
        </div>
      </div>
    </div>
  );
};
